export function formatSeconds(timeInSeconds: number) {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function getCountDeclination(value: number, words: string[]) {
    value = Math.abs(value) % 100;
    var num = value % 10;
    if (value > 10 && value < 20) return words[2];
    if (num > 1 && num < 5) return words[1];
    if (num == 1) return words[0];
    return words[2];
}

export function formatPlayCount(value: number) {
    const count = new Intl.NumberFormat('ru-RU', {
        notation: 'compact',
        maximumFractionDigits: 1
    }).format(value);
    return `${count} прослушиваний`;
}

export function formatShortPlayCount(value: number) {
    const count = new Intl.NumberFormat('ru-RU', {
        notation: 'compact',
        maximumFractionDigits: 1
    }).format(value);
    return `${count} просл.`;
}
